module.exports = __webpack_public_path__ + "static/media/calculate-01.f7d468f2.svg";